import http from '../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_CAPITAL_STATE_INVESTMENT}/dashboard`

export default ({ id }) => http.get(`${api}/${id}`)
